<template>
  <el-container>
    <el-aside>
      <MyAside ref="aside" @plugin-selected="handlePluginSelected" width="200px"></MyAside>
    </el-aside>
    <el-container>
      <el-header>
        <MyHeader></MyHeader>
      </el-header>
      <el-main>
        <MyMain ref="main" :selected-plugin="selectedPlugin"></MyMain>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "@/components/Header.vue";
import Aside from "@/components/Aside.vue"
import Main from "@/components/Main.vue";

export default {
  name: "MainHome",
  components: {
    MyHeader: Header,
    MyAside: Aside,
    MyMain: Main
  },
  data() {
    return {
      selectedPlugin: null
    }
  },
  methods: {
    handlePluginSelected(plugin) {
      this.selectedPlugin = plugin
    }
  }
};
</script>

<style scoped>
.el-container {
  height: 100vh;
  overflow: hidden;
}

.el-aside {
  width: 200px !important;
  transition: all 0.3s ease;
}

.el-main {
  padding: 24px;
  background: #f5f7fa;
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-aside {
    width: 60px !important;
  }
  
  .el-main {
    padding: 16px;
  }
}
</style>